import React from "react";
import { Download, FileText, Loader2 } from "lucide-react";
import { MainLayout } from "./MainLayout";
import { useApp } from "./AppContext";
import { useCurrentUser } from "../api/auth/useCurrentUser";
import { useMyPayslips } from "../api/payroll/useMyPayslips";
import { useDownloadPayslip } from "../api/payroll/useDownloadPayslip";


export function PayrollDocument() {
	const { setCurrentScreen } = useApp();
	const { user } = useCurrentUser();
	const { payslips, loading, error } = useMyPayslips(user?.extraId);
	const { downloading, downloadPayslip } = useDownloadPayslip();

	const handleBack = () => {
		setCurrentScreen("billing-data");
	};

	const handleDownload = async (extraId: number, payrollId: number) => {
		try {
			await downloadPayslip(extraId, payrollId);
		} catch {
			// error is handled in the hook
		}
	};

	return (
		<MainLayout showBack onBack={handleBack}>
			<div className="mb-6">
				<h1 className="text-2xl font-bold text-[var(--ucm-text-dark)] mb-2">
					Lohnabrechnung
				</h1>
				<p className="text-[var(--ucm-text-medium)]">
					Hier findest du alle deine Lohnabrechnungen von UCM
				</p>
			</div>

			{loading ? (
				<div className="flex flex-col items-center justify-center py-12">
					<Loader2 size={32} className="animate-spin text-[var(--ucm-text-medium)] mb-3" />
					<p className="text-[var(--ucm-text-medium)]">Laden...</p>
				</div>
			) : error ? (
				<div className="text-center py-12">
					<p className="text-red-500">{error}</p>
				</div>
			) : payslips.length === 0 ? (
				<div className="text-center py-12">
					<FileText size={48} className="mx-auto mb-4 text-gray-300" />
					<p className="text-[var(--ucm-text-medium)]">Noch keine Lohnabrechnungen vorhanden</p>
				</div>
			) : (
				<div className="space-y-4">
					{payslips.map((payslip) => (
						<div
							key={payslip.payroll_id}
							className="bg-white rounded-2xl p-5 shadow-[0_4px_16px_rgba(0,0,0,0.08)]"
						>
							<div className="flex items-center justify-between">
								<div className="flex items-center space-x-3">
									<div className="w-10 h-10 bg-[var(--ucm-disabled-gray)] rounded-full flex items-center justify-center">
										<FileText
											size={20}
											className="text-[var(--ucm-text-medium)]"
										/>
									</div>
									<div>
										<h3 className="font-semibold text-[var(--ucm-text-dark)]">
											Lohnabrechnung
										</h3>
										<p className="text-sm text-[var(--ucm-text-medium)]">
											{new Date(payslip.created_at).toLocaleDateString("de-DE")}
										</p>
									</div>
								</div>

								<button
									onClick={() => handleDownload(payslip.extra_id, payslip.payroll_id)}
									disabled={downloading}
									className="p-3 hover:bg-gray-50 rounded-full transition-colors disabled:opacity-50"
								>
									{downloading ? (
										<Loader2 size={20} className="animate-spin text-[var(--ucm-text-medium)]" />
									) : (
										<Download size={20} className="text-[var(--ucm-text-medium)]" />
									)}
								</button>
							</div>
						</div>
					))}
				</div>
			)}
		</MainLayout>
	);
}
